<template>
    <div class="col-12 nopads">
        <!--
        <div
            v-if="selectedContracts.length < 1"
            class="col-sm-12 nopads"
            style="font-style: italic"
        >
            <span>
                {{ $t('materialstorage.no_contracts') }}
            </span>
        </div> -->
        <span
            v-if="selectedContracts.length !== allLouhiContracts.length"
            class="span-title pt-2"
        >
            {{ $t('contracts.contract_collection.select_contracts') }}
        </span>
        <div class="col-sm-12 nopads">
            <!-- All open contracts -->
            <multiselect
                v-model="selectedContracts"
                class="multiselect_routa"
                :placeholder="$t('materialstorage.select_contract')"
                :deselect-label="$t('common.remove_selection')"
                :select-label="$t('common.select')"
                :close-on-select="false"
                :multiple="true"
                :disabled="!editable"
                open-direction="bottom"
                label="name"
                track-by="id"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="false"
                :selected-label="$t('common.selected')"
                :options="allLouhiContracts"
            >
                <template
                    #singleLabel="props"
                >
                    <span class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                    </span>
                </template>
                <template
                    #option="props"
                >
                    <div class="option__desc">
                        <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                    </div>
                </template>
                <template #noResult>
                    <span>{{ $t('common.not_found') }}</span>
                </template>
                <template #noOptions>
                    <span>{{ $t('common.no_results') }}</span>
                </template>
            </multiselect>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from "../../mixins/TimeUtils";

export default {
    name: 'LouhiMultipleContractsFilter',
    mixins: [restApi, timeUtils],
    props: {
        modelValue: {
            type: Array,
            default: function () {
                return []
            }
        },
        editable: {
            type: Boolean,
            default: true
        },
        showOnlyLouhiContracts: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            loading: false,
            allLouhiContracts: [],
            selectedContracts: this.modelValue ? this.modelValue : []
        }
    },
    watch: {
        // emit to parent when user changes selection
        selectedContracts: function () {
            this.$emit('update:modelValue', this.selectedContracts)
        },
        modelValue: function () {
            this.selectedContracts = this.modelValue
        }
    },
    mounted: function () {
        this.fetchContracts()
    },
    methods: {
        fetchContracts: function () {
            this.loading = true
            this.allLouhiContracts = []
            let now = new Date()
            var params = {}
            params.startDate = now.toISOString()
            if(this.showOnlyLouhiContracts) {
                params.showOnlyLouhiContracts = 1
            }
            this.restFetchParams(this.contractOpenUrl,
                params,
                this.handleContracts)
        },
        handleContracts: function (results) {
            this.loading = false
            if (results.data) {
                this.allLouhiContracts = results.data
            }
        },
        isSelected: function (id) {
            return this.selectedContracts.find(item => item.id === id) !== undefined
        }
    }

}
</script>
